import _ from 'underscore';
import BaseFilterView from './base-filter-view';
import CookieUtil from '../utils/cookie-util';
import ProjectUtil from '../utils/project-util';
//import template from '../../handlebars/client/bottles-list-filtered.hbs';
class BottlesListFilter extends BaseFilterView {
	constructor(options = {}) {
		super(options);
	}

	viewEvents() {
		return {
			'click .ob-btn': 'handleOrderBtnClick',
			'change input[name="results"]': 'handleResultsPerPageChange',
		};
	}

	postInitialize() {
		this.viewEvents = {};
	}

	bindings() {
		//_.bindAll(this, 'render', 'destroy');
	}

	// override as necessary for child-view-specific listeners
	childViewListeners() {
		return {};
	}

	setTemplate() {
		return import(/* webpackChunkName: "bottle-list-filtered" */ '../../handlebars/client/bottles-list-filtered.hbs')
			.then((templateModule) => {
				this.template = templateModule.default;
			});
	}

	/**
	 * Overwrite if necessary, adding to postRenderView() should suffice for your needs.
	 * 
	postRender() {
		
	}
	*/

	/**
	 * View-specific post-render actions.  Define this.listTemplate and this.apiCall here for sure.
	 */
	postRenderView() {
		this.moduleDataObj = ProjectUtil.getObjByProp(this.model.get('page').content.modules, 'id', this.$el.data('mod-id'));
		// the API call being made
		this.apiCall = 'bottles';
		// the name of the template being rendered for items list
		//this.template = template;
		// destination for filtered lists
		this.$itemListDest = $('#bottles-list-dest', this.$el);
		this.useQuerystring = (this.$el.data('use-qs') === 1) ? true : false;
		this.usePagination = (this.$el.data('paginated') === 1) ? true : false;
		this.loadEvents = (this.$el.data('load-events') === 1) ? true : false;
		this.resetPnumOnReplace = false;
		this.loadClassData = (!this.model.get('site').hasOwnProperty('bottle_classes')) ? true : false;
		this.ob_default = 'title';
		//set this.ob_filter to the querystring value of 'ob' if it exists, otherwise set it to this.ob_default
		this.ob_filter = ProjectUtil.getQueryString('ob') || this.ob_default;
		// set the order button with the data-ob-val equal to this.ob_filter to active
		$('.ob-btn[data-ob-val="' + this.ob_filter + '"]', this.$el).addClass('active');
		// check the 'resultsperpage' cookie value, default to 25.
		this.resultsPerPage = CookieUtil.getCookie('resultsperpage') || '25';
		// acceptable values of resultsPerPage are 24, 50, 100, validate that this.resultsPerPage is one of these values
		if (this.resultsPerPage !== '25' && this.resultsPerPage !== '50' && this.resultsPerPage !== '100') {
			this.resultsPerPage = '25';
		}
		// update the 'results' radio gruop with the value of this.resultsPerPage
		$('.per-page input[value="' + this.resultsPerPage + '"]', this.$el).prop('checked', true);

	}

	/**
	 * Build the querystring used for updating the url.  This should be defined per view.
	 */
	buildQueryString() {
		var //letter_filter = this.getAlphaFilterVal(),
			awards_filter = this.getSelectFilterValues('awards'),
			events_filter = this.getSelectFilterValues('events'), // get the values for the select with id 'events'
			//class_filter = this.getSelectFilterValues('class'),
			ob_filter = this.ob_filter,
			queryStringAr = [];

		if (awards_filter.length) {
			queryStringAr.push('awards=' + awards_filter);
		}
		if (events_filter.length) {
			queryStringAr.push('events=' + events_filter);
		}
		/*if (class_filter.length) {
			queryStringAr.push('class=' + class_filter);
		}*/
		/*if (letter_filter.length) {
			queryStringAr.push('letter=' + letter_filter.join('|'));
		}*/
		if (ob_filter !== this.ob_default) {
			queryStringAr.push('ob=' + ob_filter);
		}
		if (queryStringAr.length) {
			return '?' + queryStringAr.join('&');
		}
		return '';
	}

	/**
	 * Handle the click event for the order button.  update this.ob_filter to the value of the button's data-ob-val attribute.
	 */
	handleOrderBtnClick(e) {
		e.preventDefault();
		const $tBtn = $(e.currentTarget);
		// remvoe active class from all order buttons
		$('.ob-btn', this.$el).removeClass('active');
		// add active class to clicked button
		$tBtn.addClass('active');
		// set ob_filter to the value of the clicked button
		this.ob_filter = $tBtn.data('ob-val');
		//this.handleUpdateQsFilters();
		if (this.useQuerystring) {
			this.updateContent(true);
		} else {
			this.startUpdateFilters(this.getRequestData(), true);
		}
	}
	/**
	 * Build the Data Object for the API request.  This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	getRequestData() {
		// update the API call being made
		//this.apiCall = this.getQueryString('type') || 'posts';
		let requestData = null;
		if (this.useQuerystring) {
			requestData = {
				// not using querystring, get the select value
				medal: this.getQueryString('awards') || '',
				event_id: this.getQueryString('events') || '', // get the values for the querystring 'events'
				//class_id: /*this.getQueryString('class') ||*/ '',
				ob: this.getQueryString('ob') || this.ob_default,
				search: this.getTextInputValue('filter-search') || '', // $('#filter-search', this.$el).length ? $('#filter-search', this.$el).val().toLowerCase().split(' ').join('+') : '',
				pnum: this.curPage,
				inc_classes: this.loadClassData ? 1 : 0,
				perpage: this.resultsPerPage,
			};
		} else {
			requestData = {
				// not using querystring, get the select value
				medal: this.getSelectFilterValues('awards') || '',
				event_id: this.getSelectFilterValues('events') || '', // get the values for the querystring 'events'
				//class_id: /*this.getSelectFilterValues('class') ||*/ '',
				search: this.getTextInputValue('filter-search') || '', // $('#filter-search', this.$el).length ? $('#filter-search', this.$el).val().toLowerCase().split(' ').join('+') : '',
				ob: this.ob_filter,
				pnum: this.curPage,
				inc_classes: this.loadClassData ? 1 : 0,
				perpage: this.resultsPerPage,
			};
		}
		return requestData;
	}

	/**
	 * Update display of filters. This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	childUpdateFilters(/*tData*/) {
		// update checkboxes/selects here
		//this.setSelectFilterValues('expertise', tData.expertise_news);
		//this.setCheckboxFilterValues('vision', tData.vision);
		//this.setSelectFilterValues('programs', tData.program_news);
		//this.setCheckboxFilterValues('depts', tData.depts);
		//this.setCheckboxFilterValues('centers', tData.centers);

		//this.setSelectFilterValues('events', tData.events); // set the values for the select with id 'events'
		//this.setSelectFilterValues('categories', tData.categories);
	}

	childGetContent(tRes) {
		const self = this;
		// add faculty expertise to site.categories, if there are results
		if (tRes?.data?.results?.bottle_classes) {

			// process bottle_classes into new array take id as id, category as name
			let classRes = [];
			let $tSelect = null;
			let tActiveItemsAr = null;
			_.each(tRes.data.results.bottle_classes, function (tItem) {
				classRes.push({
					id: tItem.id,
					name: tItem.category
				});
			});

			// store bottle classes in site settings
			this.model.get('site').categories.bottle_classes = classRes;
			// update select with this data
			$tSelect = $('#class', self.$el);
			if ($tSelect.length) {
				// update sizing class
				$tSelect.removeClass('opt-0').addClass('opt-' + tRes.data.results.bottle_classes.length);
				// add options to select for each bottle_classes
				_.each(tRes.data.results.bottle_classes, function (item) {
					$tSelect.append('<option value="' + item.id + '">' + item.category + '</option>');
				});

				if (this.useQuerystring) {
					tActiveItemsAr = ProjectUtil.getQueryString('class').split('|');
					// activate approriate items (from querystring)
					_.each(tActiveItemsAr, function (item) {
						if (item !== '') {
							$tSelect.find('option[value="' + item + '"]').prop('selected', true);
						}
					});
				}
			}

			// store bottle events in site settings
			if (this.loadEvents) {
				this.model.get('site').categories.events = tRes.data.results.all_subevents;
				// update select with this data
				$tSelect = $('#events', self.$el);
				if ($tSelect.length) {
					// update sizing class
					$tSelect.removeClass('opt-0').addClass('opt-' + tRes.data.results.all_subevents.length);
					// add options to select for each all_subevents
					_.each(tRes.data.results.all_subevents, function (item) {
						$tSelect.append('<option value="' + item.id + '">' + $(item.title).text() + '</option>');
					});

					if (this.useQuerystring) {
						tActiveItemsAr = ProjectUtil.getQueryString('events').split('|');
						// activate approriate items (from querystring)
						_.each(tActiveItemsAr, function (item) {
							if (item !== '') {
								$tSelect.find('option[value="' + item + '"]').prop('selected', true);
							}
						});
					}
				}
			}

			// update var to prevent additional loads
			this.loadClassData = false;
		}
	}

	/**
	 * Update the cookie for results per page and set the value of this.resultsPerPage
	 */
	handleResultsPerPageChange(e) {
		e.preventDefault();
		this.resultsPerPage = $(e.currentTarget).val();
		CookieUtil.setCookie('resultsperpage', this.resultsPerPage, 365);
		// reset the page number to 1
		this.curPage = 1;
		// update the API call
		this.handleUpdateQsFilters(true);
	}

	childCleanup() {

	}


}

export default BottlesListFilter;
